import { LayoutGridAuto } from 'breeze-intelligence-kit';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { UsageCreditsOverage } from './UsageCreditsOverage';
import { UsageCreditsUsed } from './UsageCreditsUsed';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageSection = () => {
  const {
    isLoading,
    resetDays,
    showOverage,
    totalOverage,
    totalUsage,
    usageLimit,
    hasLowCredits
  } = useEnrichmentCredits();
  if (showOverage) {
    return /*#__PURE__*/_jsxs(LayoutGridAuto, {
      alignItems: "stretch",
      autoRepeat: "auto-fit",
      gap: "space-sm",
      minWidth: "10rem",
      children: [/*#__PURE__*/_jsx(UsageCreditsUsed, {
        hasLowCredits: hasLowCredits,
        isLoading: isLoading,
        resetDays: resetDays,
        totalUsage: totalUsage,
        usageLimit: usageLimit
      }), /*#__PURE__*/_jsx(UsageCreditsOverage, {
        credits: totalOverage,
        isLoading: isLoading
      })]
    });
  }
  return /*#__PURE__*/_jsx(UsageCreditsUsed, {
    hasLowCredits: hasLowCredits,
    isLoading: isLoading,
    resetDays: resetDays,
    totalUsage: totalUsage,
    usageLimit: usageLimit
  });
};